import { render, staticRenderFns } from "./Discord.vue?vue&type=template&id=3b80804e&scoped=true"
import script from "./Discord.vue?vue&type=script&lang=js"
export * from "./Discord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b80804e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b80804e')) {
      api.createRecord('3b80804e', component.options)
    } else {
      api.reload('3b80804e', component.options)
    }
    module.hot.accept("./Discord.vue?vue&type=template&id=3b80804e&scoped=true", function () {
      api.rerender('3b80804e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/oauthFPX/social/Discord.vue"
export default component.exports